export default {"src":"/_next/static/media/weight-icon.bdf12880.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};